<aside class="bl-history" [attr.aria-label]="label('Conversaciones', 'Conversations')">

  <div class="bl-history-head">
    <span class="bl-history-title">{{ label('Conversaciones', 'Conversations') }}</span>
    <button type="button" class="bl-history-collapse" (click)="closePanel.emit()"
      [ngbTooltip]="label('Ocultar el panel', 'Hide the panel')" container="body" placement="bottom">
      <i data-feather="chevrons-left" size="16"></i>
    </button>
  </div>

  <button type="button" class="bl-history-new" (click)="newChat.emit()" [disabled]="busy">
    <i data-feather="plus" size="15"></i>
    {{ label('Nuevo chat', 'New chat') }}
  </button>

  <div class="bl-history-search">
    <i data-feather="search" size="14"></i>
    <input type="text" [(ngModel)]="search" name="history-search"
      [placeholder]="label('Buscar en tus chats', 'Search your chats')" />
    <button type="button" class="bl-history-search-clear" *ngIf="search" (click)="search = ''">
      <i data-feather="x" size="13"></i>
    </button>
  </div>

  <div class="bl-history-list">

    <div class="bl-history-loading" *ngIf="loading">
      <span class="bl-typing"><i></i><i></i><i></i></span>
    </div>

    <ng-container *ngFor="let group of groups; trackBy: trackByGroup">
      <span class="bl-history-group">{{ group.label }}</span>

      <div class="bl-history-item" *ngFor="let chat of group.chats; trackBy: trackByChat"
        [class.is-active]="chat.id === activeId" (click)="select(chat)">

        <!-- Renombrado en línea -->
        <input #renameInput class="bl-history-rename" *ngIf="renamingId === chat.id; else chatRow"
          type="text" [(ngModel)]="renameText" [name]="'rename-' + chat.id"
          (click)="$event.stopPropagation()" (blur)="commitRename(chat)"
          (keydown.enter)="commitRename(chat)" (keydown.escape)="cancelRename()" />

        <ng-template #chatRow>
          <span class="bl-history-item-body">
            <span class="bl-history-item-title text-truncate">{{ chat.title }}</span>
            <small class="bl-history-item-meta">
              {{ chatDate(chat.updatedAt) }}
              <ng-container *ngIf="chat.messageCount">· {{ chat.messageCount }}</ng-container>
            </small>
          </span>

          <span class="bl-history-item-actions">
            <button type="button" class="bl-history-action" (click)="startRename(chat, $event)"
              [attr.aria-label]="label('Renombrar', 'Rename')">
              <i data-feather="edit-2" size="13"></i>
            </button>
            <button type="button" class="bl-history-action bl-history-action--danger"
              (click)="remove(chat, $event)" [attr.aria-label]="label('Eliminar', 'Delete')">
              <i data-feather="trash-2" size="13"></i>
            </button>
          </span>
        </ng-template>
      </div>
    </ng-container>

    <p class="bl-history-empty" *ngIf="empty">
      <ng-container *ngIf="search; else noChatsYet">
        {{ label('Ningún chat coincide con la búsqueda', 'No chat matches your search') }}
      </ng-container>
      <ng-template #noChatsYet>
        {{ label('Todavía no tienes conversaciones guardadas', 'You have no saved conversations yet') }}
      </ng-template>
    </p>
  </div>
</aside>
